import type { AxiosInstance, AxiosResponse, AxiosError } from 'axios'
import { INACTIVE_SESSION_ERROR_CODE } from 'const'
import { clearAuthState } from 'logic/auth'
export const refreshTokenMiddleware = (axios: AxiosInstance) =>
	axios.interceptors.response.use(
		function (response: AxiosResponse) {
			if (response && response.headers && response.headers['x-smsleopard-token']) {
				localStorage.setItem('x-smsleopard-token', response.headers['x-smsleopard-token'] as string)
			}
			return response
		},
		function (error: AxiosError) {
			return Promise.reject(error)
		},
	)

let isRedirectingToLogin = false

export const checkForExpiredToken = (axios: AxiosInstance) =>
	axios.interceptors.response.use(
		function (response: AxiosResponse) {
			return response
		},
		function (e: AxiosError<{ error_code?: string }>) {
			if (e.response) {
				const { status } = e.response
				if (status === 401 && !isRedirectingToLogin) {
					isRedirectingToLogin = true
					rememberSignOutReason(e.response.data?.error_code)
					redirectToLogin()
				}
			}
			return Promise.reject(e)
		},
	)

// smsl-backend#2937: an idle session ends with session_expired, one past its 48h cap with
// token_invalid (the JWT exp). Only a user who was signed in gets the notice on /login.
const SIGN_OUT_REASON_KEY = 'signout_reason'

export function rememberSignOutReason(errorCode: string | undefined) {
	if (errorCode !== 'session_expired' && errorCode !== 'token_invalid') return
	// Already on /login there is no redirect, so nothing would read the reason until a later visit.
	if (window.location.pathname === '/login') return
	try {
		if (localStorage.getItem('x-smsleopard-token')) sessionStorage.setItem(SIGN_OUT_REASON_KEY, 'session_expired')
	} catch {}
}

export function takeSignOutReason(): string | null {
	try {
		const reason = sessionStorage.getItem(SIGN_OUT_REASON_KEY)
		sessionStorage.removeItem(SIGN_OUT_REASON_KEY)
		return reason
	} catch {
		return null
	}
}

export const confirmSessionStatus = (axios: AxiosInstance) => {
	axios.interceptors.response.use(
		(response: AxiosResponse) => response,
		(error: AxiosError<{ error_code?: string }>) => {
			if (error.response?.data?.error_code === INACTIVE_SESSION_ERROR_CODE) {
				if (window.location.pathname !== '/otp-verification') {
					window.location.replace('/otp-verification')
				}
			}
			return Promise.reject(error)
		},
	)
}

function redirectToLogin() {
	clearAuthState()
	if (window.location && window.location.pathname !== '/login') {
		const origin = window.location.origin
		let newURL = window.location.href
		if (!window.location.search) newURL = newURL.replace(origin, origin + `/login?prev=`)
		window.location.href = newURL
	}
}
